import 'core-js/stable';
import 'regenerator-runtime/runtime';
import ContactTab from './contact-tab';
import MetaTelBox from './meta-tel-box';
import MetaVacancyBox from './vacancie-meta-box';

class SalientChild {
  constructor() {
    this.ContactTab = new ContactTab();
    this.MetaTelBox = new MetaTelBox();
    this.MetaVacancyBox = new MetaVacancyBox();
    this.$loadingOverlay = $('.loading-overlay');
    this.$WantSwiggles = $('.want-swiggles');

    this.linksToUpdateOnTouchDevices = $('.update-href-for-touch-devices');
    this.linksToRemoveOnMouseDevices = $('.remove-on-mouse-devices');
  }

  init() {
    $('html').addClass('js-loaded');
    this.ContactTab.init();
    this.MetaVacancyBox.init();
    this.MetaTelBox.init();
    this.swiggles();
    this.removeLoadingOverlay();

    this.updateNavigationForDevice();

    const downloads = document.querySelectorAll('.auto-download');
    if (downloads) {
      downloads.forEach(download => download.click());
    }
  }

  swiggles() {
    this.$WantSwiggles.parent().addClass('swiggles');
  }

  removeLoadingOverlay() {
    this.$loadingOverlay[0].addEventListener('transitionend', () => {
      this.$loadingOverlay.hide();
    });
  }

  updateNavigationForDevice() {
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.linksToRemoveOnMouseDevices.each((index, listItem) => listItem.classList.add('u-hide-desktop'));
    } else {
      this.linksToUpdateOnTouchDevices.each((index, listItem) => {
        const link = listItem.querySelector(':scope > a[href]');
        link.href = '#';
      });
    }
  }
}

$(document).ready(() => {
  const sc = new SalientChild();
  sc.init();
});
